import { db } from '../../firebase';

const state = {
  blogPosts: []
};

const getters = {
  blogPosts(state) {
    return state.blogPosts;
  },
  blogPostById: state => postId => {
    return state.blogPosts.find(p => p.id === postId);
  }
};

const mutations = {
  SET_BLOG_POSTS(state, blogPosts) {
    state.blogPosts = blogPosts;
  },
  SET_BLOG_POST_CONTENT(state, payload) {
    let post = state.blogPosts.find(p => p.id === payload.postId);
    post.content = payload.content;
  }
};

const actions = {
  async fetchBlogPosts({ commit }) {
    try {
      let querySnapshot = await db
        .collection('blog-posts')
        .orderBy('date', 'desc')
        .get();
      const posts = [];
      querySnapshot.forEach(doc => {
        posts.push({ id: doc.id, ...doc.data() });
      });
      posts.forEach(p => (p.content = null));
      commit('SET_BLOG_POSTS', posts);
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    }
  },

  //Get the file and store contents
  async fetchBlogPostContent({ state, commit }, postId) {
    console.log('fetch blog content from firestore');
    try {
      const url = state.blogPosts.find(p => p.id === postId).url;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to fetch blog post content');
      }

      const content = await response.text();
      commit('SET_BLOG_POST_CONTENT', { postId, content });
      // Process the content as needed
    } catch (error) {
      console.error('Error fetching blog post content:', error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
